import PropTypes from "prop-types";
import { Box, Card, CardContent, Typography } from "@mui/material";
import GaugeChart from "react-gauge-chart";
import { useMemo } from 'react';

const arredondar = (n) => Math.max(0, Math.min(1, n));

const ProdutGeral = ({ horasDisp, horasProd }) => {

    const percent = useMemo(() => {
        const disp = Number(horasDisp) || 0;
        const prod = Number(horasProd) || 0;
        if (disp <= 0) return 0;
        const ratio = prod / disp;
        if ( ratio > 100 ) return 100;
        return arredondar(Number(ratio.toFixed(4)));
    }, [horasDisp, horasProd]);

    return (
        <Box sx={{ position: "relative", height: "100%" }}>
            <Card sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                background: "transparent",
                boxShadow: "0 8px 28px rgba(26, 56, 101, 0.15), 0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: "16px",
                border: "1px solid rgba(100, 125, 238, 0.2)",
                overflow: "hidden",
                position: "relative",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0, left: 0, right: 0,
                    height: "4px",
                    background: "linear-gradient(90deg, #1A3865, #647DEE, #269FFB)",
                },
            }}>
                <CardContent sx={{
                    flexGrow: 1,
                    pt: 3,
                    pb: "16px !important",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 700,
                        color: "#1A3865",
                        letterSpacing: "0.4px",
                        mb: 0.5,
                    }}>
                        Aproveitamento Geral
                    </Typography>
                    <GaugeChart
                        align="center"
                        id="productivity-gauge"
                        nrOfLevels={3}
                        percent={percent}
                        arcsLength={[0.6, 0.2, 0.2]}
                        colors={["#E57373", "#FFD54F", "#81C784"]}
                        arcWidth={0.25}
                        arcPadding={0.02}
                        textColor={"#1A3865"}
                        needleColor={"#78909C"}
                        animate={true}
                        animDelay={200}
                        style={{ width: "100%", maxWidth: "320px" }}
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

ProdutGeral.propTypes = {
  horasDisp: PropTypes.number,
  horasProd: PropTypes.number,
};

export default ProdutGeral;
